import type { TestableComponent } from '@mweb/types';
import { useEffect, useState } from 'react';

import { Tabs, TabsList } from 'components/productdetail/ReviewSummarization/Tabs';
import { TabsHeader } from 'components/productdetail/ReviewSummarization/TabsHeader/TabsHeader';
import { TabsContent } from 'components/productdetail/ReviewSummarization/TabsContent/TabsContent';
import useMartyContext from 'hooks/useMartyContext';
import type { ReviewSummarizationResponseAspects } from 'types/reviewSummarization';

export interface TabsProps extends TestableComponent {
  aspects: ReviewSummarizationResponseAspects[];
  onTabOpen?: (tab: string) => void;
  selectedTab?: string;
  isSuppressContent?: boolean;
  isWrapHeaderEnabled?: boolean;
}

export const TabsContainer = ({ aspects, testId, selectedTab, isSuppressContent, onTabOpen, isWrapHeaderEnabled = true }: TabsProps) => {
  const { testId: getTestId } = useMartyContext();
  const [openTab, setOpenTab] = useState(selectedTab);

  useEffect(() => {
    setOpenTab(selectedTab);
  }, [selectedTab]);

  const handleOpenTab = (tab: string) => {
    setOpenTab(tab);
    onTabOpen?.(tab);
  };

  const handleValueChange = (value: string) => {
    setOpenTab(value);
    onTabOpen?.(value);
  };

  return (
    <Tabs value={openTab} onValueChange={handleValueChange} className="flex flex-col items-start gap-y-6" data-test-id={getTestId(testId)}>
      <TabsList isWrap={isWrapHeaderEnabled}>
        {aspects.map(({ name, sentiment }) => (
          <TabsHeader testId={`${getTestId(testId)}-header-${name}`} key={name} sentiment={sentiment} handleOpenTab={handleOpenTab}>
            {name}
          </TabsHeader>
        ))}
      </TabsList>
      {!isSuppressContent &&
        aspects.map(({ name, summary, reviewCount, positiveReviewCount, negativeReviewCount }) => (
          <TabsContent
            testId={`${getTestId(testId)}-content-${name}`}
            key={name}
            headerName={name}
            reviewCount={reviewCount}
            positiveReviewCount={positiveReviewCount}
            negativeReviewCount={negativeReviewCount}
            handleOpenTab={handleOpenTab}
          >
            {summary}
          </TabsContent>
        ))}
    </Tabs>
  );
};
